module.exports = __webpack_public_path__ + "sa.c63bf725633fd74a6177.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/sa.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/sa.svg
// module chunks = styles